'use strict';

var ConfigurationParametersDirective = function ConfigurationParametersDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/configuration-parameters.html'),
    controller: 'ConfigurationParametersController',
    link: function link(scope, element) {
      element.find('.advanced-hep-info-icon').popover();
    }
  };
};
ConfigurationParametersDirective.$inject = [];
module.exports = ConfigurationParametersDirective;